/* Mirrors the hero's price dropdown into the horizontal facets row above the
   product grid, and closes any open price dropdown on an outside click.
   Extracted from sections/helm-collection-hero.liquid. Runs once per page and
   finds the hero itself, so it needs no section id. */
(function () {
  var hero = document.querySelector('.helm-hero');
  if (!hero) return;

  var source = hero.querySelector('[data-helm-price]');

  function facetsRow() {
    return (
      document.querySelector('.facets--horizontal .facets__form') ||
      document.querySelector('.facets--horizontal .facets__form-wrapper') ||
      document.querySelector('.facets--horizontal')
    );
  }

  function placeTopbarPrice() {
    if (!source) return;
    var bar = facetsRow();
    if (!bar) return;
    if (bar.querySelector('.helm-price--topbar')) {
      hero.classList.add('helm-hero--price-placed');
      return;
    }
    var clone = source.cloneNode(true);
    clone.classList.add('helm-price--topbar');
    clone.removeAttribute('open');
    clone.removeAttribute('data-helm-price');
    bar.insertBefore(clone, bar.firstChild);
    hero.classList.add('helm-hero--price-placed');
  }

  placeTopbarPrice();
  document.addEventListener('DOMContentLoaded', placeTopbarPrice);

  /* Horizon re-renders the facets row on every filter change, so the clone has
     to be re-inserted each time that subtree is replaced. */
  new MutationObserver(placeTopbarPrice).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.helm-price[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();